export default {
    isLoading: state => state.isLoading,
    levels: state => state.levels,
};



// WEBPACK FOOTER //
// ./src/taskflex/levels/store/_getters.js